// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"0239bd85","309":"1e01eaa4","491":"c11455ad","720":"0cf8e788","729":"c8a39acf","748":"a1728765","818":"3f2498c4","843":"28abaffb"}[chunkId] + ".chunk.css";
};